"use strict";
// copied from image-service
Object.defineProperty(exports, "__esModule", { value: true });
exports.CDN_URL_PROTOCOL = 'seneca-image-cdn';
var Format;
(function (Format) {
    Format["JPG"] = "jpg";
    Format["JPEG"] = "jpeg";
    Format["PNG"] = "png";
})(Format = exports.Format || (exports.Format = {}));
var Fit;
(function (Fit) {
    Fit["COVER"] = "cover";
    Fit["CONTAIN"] = "contain";
    Fit["FILL"] = "fill";
    Fit["INSIDE"] = "inside";
    Fit["OUTSIDE"] = "outside";
})(Fit = exports.Fit || (exports.Fit = {}));
var Position;
(function (Position) {
    // SHARP POSITION
    Position["TOP"] = "top";
    Position["RIGHT_TOP"] = "right top";
    Position["RIGHT"] = "right";
    Position["RIGHT_BOTTOM"] = "right bottom";
    Position["BOTTOM"] = "bottom";
    Position["LEFT_BOTTOM"] = "left bottom";
    Position["LEFT"] = "left";
    Position["LEFT_TOP"] = "left top";
    // SHARP GRAVITY
    Position["NORTH"] = "north";
    Position["NORTHEAST"] = "northeast";
    Position["EAST"] = "east";
    Position["SOUTHEAST"] = "southeast";
    Position["SOUTH"] = "south";
    Position["SOUTHWEST"] = "southwest";
    Position["WEST"] = "west";
    Position["NORTHWEST"] = "northwest";
    Position["CENTRE"] = "centre";
    // SHARP STRATEGY (requires fit: cover)
    Position["ENTROPY"] = "entropy";
    Position["ATTENTION"] = "attention";
})(Position = exports.Position || (exports.Position = {}));
var Transformer;
(function (Transformer) {
    Transformer["HEIGHT"] = "height";
    Transformer["WIDTH"] = "width";
    Transformer["POSITION"] = "position";
    Transformer["FIT"] = "fit";
    Transformer["BACKGROUND"] = "background";
    Transformer["QUALITY"] = "quality";
    Transformer["ROTATE"] = "rotate";
})(Transformer = exports.Transformer || (exports.Transformer = {}));
var TransformersMap;
(function (TransformersMap) {
    TransformersMap["h"] = "height";
    TransformersMap["w"] = "width";
    TransformersMap["p"] = "position";
    TransformersMap["f"] = "fit";
    TransformersMap["b"] = "background";
    TransformersMap["q"] = "quality";
    TransformersMap["r"] = "rotate";
})(TransformersMap = exports.TransformersMap || (exports.TransformersMap = {}));
exports.ReverseTransformersMap = Object.freeze(Object.keys(TransformersMap).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [TransformersMap[key]]: key })), {}));
const enumToObject = (enumObj) => Object.freeze(Object.keys(enumObj).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: enumObj[key] })), {}));
exports.FormatT = enumToObject(Format);
exports.FitT = enumToObject(Fit);
exports.PositionT = enumToObject(Position);
exports.TransformerT = enumToObject(Transformer);
